import React from 'react';
import {AppText, AppErrorText} from './Typography';

interface AppTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

const AppTextarea: React.FC<AppTextareaProps> = ({label, error, className = '', ...props}) => (
  <div className="w-full">
    {label && <AppText className="block mb-2 font-bold">{label}</AppText>}
    <textarea
      className={`w-full rounded-xl border bg-white px-4 py-3 text-lg font-normal text-grayText font-zain outline-none transition-all
        ${error ? 'border-red-500' : 'border-gray-200 focus:border-gray-500'}
        placeholder-gray-400
        ${className}`}
      {...props}
    />
    {error && <AppErrorText className="text-sm mt-2">{error}</AppErrorText>}
  </div>
);

export default AppTextarea;
